<!-- eslint-disable no-irregular-whitespace -->
<template>
  <page>

    <div class="service-content">
      <div class="wrapper">

        <center>
          <div class="service-content-title">
            サービスの詳細
          </div>
        </center>

        <!-- service-content -->
        <div class="service-content">

          <p class="service-text">
            <img src="~@/assets/images/point-title-img.png" alt="スズキ定額マイカーのポイント" class="pc tab">
            <img src="~@/assets/images-sp/point-title-img.png" alt="スズキ定額マイカーのポイント" class="mobi">
          </p>

          <!-- step01 -->
          <!-- service-box -->
          <section class="service-box service-box01" id="link01">

            <p class="service-stepicon pc tab"><img src="~@/assets/images/service/service-step01.png" alt="01"></p>

            <h2 class="service-title big"><span class="big red">6ケ月契約</span>だから<br class="mobi"><span class="big blue">気軽</span>に利用できる。<br><span class="big blue">車との新しい付き合い方</span><br class="mobi">のご提案。</h2>

            <p class="service-box01-pic"><img src="~@/assets/images/service/service-01-pic-1.png" alt="毎月定額だから安心！頭金なし！" class="pc tab"></p>
            <img src="~@/assets/images/service/sp/service-01-pic-1.png" width="587" height="353" class="mobi">

            <div class="service-box-list_month_service">
              <img src="~@/assets/images/service/service-01-pic-7.png" alt="月額料金に含まれるサービス" class="pc tab">
              <img src="~@/assets/images/service/service-01-pic-7-sp.png" alt="月額料金に含まれるサービス" class="mobi">
            </div>

            <div class="top-point-content-in-box-text">
              「クルマが必要なのは短期間だけ」<br>「クルマがある生活を試してみたい」<br>「新車の購入を考えているけど、<br class="mobi">実際に試してみたい」<br>そんな、<span class="orange medium">お客様のさまざまなニーズ</span><br>にお応えします。
            </div>

            <p class="service-text02">スズキ定額マイカーは6ケ月間の契約で、再契約も可能です。一時的に使いたい、必要な期間<br class="pc">ずっと
              使い続けたい、どちらのご要望も叶えます。</p>

            <div class="service-box-list">
              <p class="service-box-list-tit">こんな人におすすめ</p>
              <ul class="service-box-list-area">
                <li class="service-box-list-txt">自動車保険の加入、<br>税金の支払いなど、<br>手続きが煩わしい
                  <img src="~@/assets/images/service/service-01-pic-2.jpg" alt="">
                </li>
                <li class="service-box-list-txt">転勤などで、<br>急に車が必要になった
                  <img src="~@/assets/images/service/service-01-pic-3.jpg" alt="">
                </li>
                <li class="service-box-list-txt">一時的な通院のために<br>車が必要になった
                  <img src="~@/assets/images/service/service-01-pic-4.jpg" alt="">
                </li>
                <li class="service-box-list-txt">いろんなクルマに<br>乗ってみたい！
                  <img src="~@/assets/images/service/service-01-pic-5.jpg" alt="">
                </li>
                <li class="service-box-list-txt">車が必要になったけど、<br>いつまで使用するか<br>わからない
                  <img src="~@/assets/images/service/service-01-pic-6.jpg" alt="">
                </li>
              </ul>
            </div>

            <div class="service-box01-content02">
              <h2 class="service-title02">もしもの時も安心！充実の補償内容</h2>

              <p class="service-text02">スズキ定額マイカーは自動車保険込みのカーサブスクリプションサービス。<br>
                保険の内容も車両保険つきの充実した内容で、もしもの時も安心。契約者の年齢によって保険料が変わるということもありません。</p>

              <h2 class="service-title03">主な補償内容</h2>
              <table class="service-box01-table sans">
                <tr>
                  <th colspan="2" style="background: #f2f2f2;">補償内容</th>
                  <td style="background: #f2f2f2;">保険金額・サービス内容</td>
                </tr>
                <tr>
                  <th colspan="2">対人・対物賠償<br class="mobi">（相手方への賠償）</th>
                  <td>無制限</td>
                </tr>
                <tr>
                  <th colspan="2">人身傷害<br class="mobi">（おからだの補償）</th>
                  <td>5,000万円</td>
                </tr>
                <tr>
                  <th colspan="2" style="border-bottom:  #ccc solid 2px;">車両保険</th>
                  <td style="border-bottom:  #ccc solid 2px;">一般条件<br class="mobi">（免責金額：5万円）</td>
                </tr>
                <tr>
                  <th rowspan="3" style="width: 0%;">特約</th>
                  <td>ロードサービス</td>
                  <td>緊急時応急対応：事故、故障、バッテリー上がり、インロック、スペアタイヤ交換等（15万円限度）<br>付帯サービス：燃料切れ時ガソリン配達サービス（10ℓ）</td>
                </tr>
                <tr>
                  <td>レンタカー特約</td>
                  <td>「車両搬送・応急対応・レンタカー費用等補償特約（30日）」による「レンタカー費用」「車両引取費用」「代替交通費用」の補償と、それに伴う各種案内・手配等のサービス
                  </td>
                </tr>
                <tr>
                  <td>弁護士費用特約<br>（自動車事故型）</td>
                  <td>契約車両の事故で、相手方に法律上の損害賠償請求をする場合の弁護士費用および法律相談費用を補償<br>（300万円限度）
                  </td>
                </tr>
              </table>
            </div>

            <div class="service-box01-content02">
              <h2 class="service-title02">安心・充実の装備</h2>

              <p class="service-text02">スズキ定額マイカー掲載車両は、全車にカーナビ、ETC、ドライブレコーダーを標準装備！<br>
                クルマを受け取ったその時から安心・快適なマイカーライフが始まります。</p>

              <h2 class="service-title03">標準装備</h2>
              <table class="service-box01-table-2 sans">

                <tr>
                  <th>カーナビ</th>
                  <td>フロアマット</td>
                </tr>
                <tr>
                  <th>ETC</th>
                  <td>ドアバイザー</td>
                </tr>
                <tr>
                  <th>ドライブレコーダー</th>
                  <td>スタッドレスタイヤ（有償）</td>
                </tr>
              </table>
            </div>

          </section>
          <!-- /service-box -->

          <!-- step02 -->
          <!-- service-box -->
          <section class="service-box service-box02" id="link02">

            <p class="service-stepicon pc tab"><img src="~@/assets/images/service/service-step02.png" alt="02"></p>

            <h2 class="service-title big">申し込みは<span class="big red">スマホで簡単。</span><br>納車まで来店不要だから<br class="mobi tab"><span class="big blue">手続きラクラク。</span></h2>

            <p class="service-box01-pic"><img src="~@/assets/images/point-img-2.png" alt="" class="pc"></p>
            <img src="~@/assets/images-sp/point-img-2.png" width="587" height="353" class="mobi">

            <div class="top-point-content-in-box-text">
              申し込み・審査はWEBで対応。<br>契約手続きも自宅でできるので、納車まで来店不要。<br><span class="orange medium">自分の時間に合わせて</span><br class="mobi">手続きを進めることができます。
            </div>

            <div class="service-box01-contents02">
              <img src="~@/assets/images/service/service-02-img1.png" alt="">
            </div>

            <div class="service-box01-contents03-inner">
              <h2 class="service-title02">保険の面倒な契約手続きや、<br>忘れがちな税金の支払い手続きも不要です</h2>

              <div class="service-box01-contents03">
                <div>
                <img src="~@/assets/images/service/service-02-img2.png" alt="">
                  <p class="komikomi sans">すべてコミコミ！</p>
                </div>
                <p class="service-text02">保険の煩わしい手続きは一切不要。スズキ定額マイカーへの申し込みだけで、納車時には保険が開始されます。<br>
                  税金も月額利用料に含まれているので、お客様が税金の支払い手続きをする必要もありません。</p>
              </div>
            </div>


            <div class="service-box01-contents04-inner">
              <h2 class="service-title02">お支払いはクレジットカードで<br class="mobi">ラクラク！</h2>

              <div class="service-box01-contents04">
                <p class="service-text02">月々のお支払いはクレジットカード決済。あらたに口座振替の手続きをする必要もありません。</p>
                  <img src="~@/assets/images/service/service-02-img3.png" alt="">
              </div>
            </div>

            <div class="service-box01-btn-wrapper">
              <router-link class="service-box01-btn sans" to="/flow">ご利用の流れを詳しく見る</router-link>
            </div>

          </section>
          <!-- /service-box -->

          <!-- step03 -->
          <!-- service-box -->
          <section class="service-box service-box03" id="link03">

            <p class="service-stepicon pc tab"><img src="~@/assets/images/service/service-step03.png" alt="03"></p>

            <h2 class="service-title big"><span class="big red">先進安全技術</span>を搭載した<br>スズキ車をラインアップ</h2>

            <p class="service-box01-pic"><img src="~@/assets/images/service/service-cars.png" alt="" class="pc tab"></p>
            <img src="~@/assets/images/service/sp/service-03-step.png" width="587" height="353" class="mobi">

            <div class="top-point-content-in-box-text">
              対象車種は、<br class="mobi">「スズキセーフティサポート」を搭載した<br class="pc tab">スズキ認定中古車。<br class="mobi">初めて車を運転される方から、<br class="mobi">子育て世代、<br class="pc tab">運転に不安を感じはじめたシニア世代の方まで、<br class="pc tab"><span class="orange medium">安心・安全なマイカーライフ</span>を送れます。
            </div>

            <p class="service-text02">ヒヤリとする一瞬までも最小限に抑え、事故そのものを未然に防ぐ予防安全技術「スズキ セーフティ サポート」。スズキ定額マイカーでは、 「スズキ セーフティ サポート」を搭載したクルマを多数ラインアップ。</p>
            <div class="safety-support">
              <img src="~@/assets/images/service/service-03-pic-1.gif" alt="">
            </div>

            <h2 class="service-title03">スズキ定額マイカー <br class="mobi">全車種搭載機能</h2>

            <div class="service-equipment-img-1 sans">

              <div class="service-equipment-img-1-1">
                <img src="~@/assets/images/service/service-03-pic-2.gif" alt="">
                <p>後退時<br>ブレーキサポート</p>
              </div>
              <div class="service-equipment-img-1-2">
                <img src="~@/assets/images/service/service-03-pic-3.gif" alt="">
                <p>誤発進抑制機能</p>
              </div>
              <div class="service-equipment-img-1-3">
                <img src="~@/assets/images/service/service-03-pic-4.gif" alt="">
                <p>車線逸脱警報機能</p>
              </div>
            </div>

            <div class="service-equipment-img-2 sans">

              <div class="service-equipment-img-2-1">
                <img src="~@/assets/images/service/service-03-pic-5.gif" alt="">
                <p>ハイビームアシスト</p>
              </div>
              <div class="service-equipment-img-2-2">
                <img src="~@/assets/images/service/service-03-pic-6.gif" alt="">
                <p>先行者発進お知らせ機能</p>
              </div>
            </div>

            <h2 class="service-title02">全車種スズキ認定中古車で安心！<br>車両の状態もチェックできます</h2>

            <p class="service-text02">スズキ定額マイカーのクルマはすべて検査のプロであるスズキ認定検査員が車両をチェックした「スズキ認定中古車」。車両状態証明書で、車両状態を詳しく確認できるので、来店しなくてもキズやへこみなどの情報も分かります。</p>

            <div class="service-in-box-area">
              <p class="service-in-box-area-txt">（イメージ）</p>

              <div class="service-in-box">

                <!-- car-content-in-box -->

                <div class="car-content-in-box-title sans">
                  車両品質評価
                </div>

                <!-- of -->
                <div class="of">

                  <div class="car-content-in-box-evaluation">
                    <span class="text">総合評価</span>
                    <span class="big">5</span>
                  </div>

                  <div class="car-content-in-box-evaluation-in of sans">
                    <p>目立たない傷、凹みなどが少しあるが、概ね良好な状態です。</p>
                  </div>

                </div>
                <!-- /of -->

                <table class="car-content-in-box-tb sans pc tab">
                  <tr>
                    <th class="th-1">走行</th>
                    <td class="td-1">実走行距離です</td>
                    <th class="th-2">内装</th>
                    <td class="td-2">目立つ損傷はありません</td>
                  </tr>
                  <tr>
                    <th class="th-1">外装</th>
                    <td class="td-1">目立つ損傷はありません</td>
                  </tr>
                </table>

                <table class="car-content-in-box-tb sans mobi">
                  <tr>
                    <th class="th-1">走行</th>
                    <td class="td-1">実走行距離です</td>
                  </tr>
                  <tr>
                    <th class="th-1">内装</th>
                    <td class="td-1">目立つ損傷はありません</td>
                  </tr>
                  <tr>
                    <th class="th-1">外装</th>
                    <td class="td-1">目立つ損傷はありません</td>
                  </tr>
                </table>

                <!-- of -->
                <div class="of">
                  <div class="car-content-in-box-certificate sans">
                    <a class="service-in-box-certificate-btn sans">
                      車両状態証明書を見る
                    </a>
                    <p>車両状態証明書は、表示項目・方法、運用体制について、一般社団法人自動車公正取引協議会の定める基準を満たした「スズキ認定中古車制度」に基づき作成したものです</p>
                  </div>
                </div>
                <!-- /of -->

              </div>
            </div>
          </section>
          <!-- /service-box -->

          <div class="srarch-box pc tab">
            <p class="search-box-tit">利用可能なクルマを探す</p>
            <ul class="search-box-btnarea first-child">
              <li class="search-box-btnarea-btn"><router-link to="/car?area=埼玉"><span>埼玉</span>エリアで探す</router-link></li>
              <li class="search-box-btnarea-btn"><router-link to="/car?area=大阪"><span>大阪</span>エリアで探す</router-link></li>
            </ul>
            <ul class="search-box-btnarea">
              <li class="search-box-btnarea-btn"><router-link to="/car?area=宮城"><span>宮城</span>エリアで探す</router-link></li>
              <li class="search-box-btnarea-btn"><router-link to="/car?area=福岡"><span>福岡</span>エリアで探す</router-link></li>
            </ul>
          </div>
          <!-- /service-content -->

        </div>
      </div>
    </div>

  </page>
</template>
<!-- eslint-enable no-irregular-whitespace -->

<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import Page from '@/components/Page.vue';
import scripts from '@/assets/service.js';

export default defineComponent({
  components: {
    Page,
  },
  setup () {
    onMounted(() => {
      scripts.serviceScript();
    });
  },
});
</script>

<style lang="scss" scoped>
  .header-logo {
    margin-top: 80px;
  }
</style>